import React, { Component } from "react";
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { PrimaryButtonComponent } from "../../../CommonComponents/commonStyles";
import { PickTimeFrame, CustomModal } from './styles';
import DateSelectorComponent from './DateTimepicker/DateSelector';
let currentDates = { 'value': [], 'dateString': [] }
export class TimeFrameComponent extends Component {
  constructor(props) {
    super(props);
    this.state = {
      visible: false,
      dates: ""
    };
    this.toTimeFrame = this.toTimeFrame.bind(this);
    this.startDate = this.startDate.bind(this);
    this.endDate = this.endDate.bind(this);
  }

  handleOk = e => {
    this.setState({
      visible: false
    });
  };

  toTimeFrame = (dates) => {
    if (!dates) {
      this.setState({ dates: "" });
    }
    else {
      currentDates = dates
    }
  }

  startDate = (value, dateString) => {
    currentDates.value[0] = value;
    currentDates.dateString[0] = dateString;
  }

  endDate = (value, dateString) => {
    currentDates.value[1] = value;
    currentDates.dateString[1] = dateString;
  }

  render() {
    return (
      <>
        <CustomModal
          data-test="document-centre-time-frame"
          width="700px"
          height="500px"
          visible={this.props.visible}
          onCancel={this.props.onCancel}
          footer={
            <PrimaryButtonComponent onClick={() => { this.props.onFilterClick(currentDates) }}>
              Filter
            </PrimaryButtonComponent>
          }
        >
          <PickTimeFrame>Pick Time Frame</PickTimeFrame>
          <DateSelectorComponent
            open={this.props.visible}
            dateValues={this.props.dateValues}
            toTimeFrame={this.toTimeFrame}
            startDate={this.startDate}
            endDate={this.endDate}
          />
        </CustomModal>
      </>
    );
  }
}

TimeFrameComponent.propTypes = {
  dropdownVal: PropTypes.string,
  visible: PropTypes.bool,
  onCancel: PropTypes.func.isRequired,
  onFilterClick: PropTypes.func.isRequired,
}

const mapStateToProps = state => (
  {
    dropdownVal: state.getIn(['documentCentre', 'selectDropdown']),
  }
);

export default connect(mapStateToProps, null)(TimeFrameComponent);
